<mat-toolbar class="subtitulo">Beneficiário</mat-toolbar>


<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form [formGroup]="form" role="form">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div fxFlex="35%" fxLayoutGap="20px">
                    <mat-form-field style="width: 100%;" fxLayoutGap="20px" fxFlexOffset="20px">
                        <input matInput maxlength="255" name="beneficiario" placeholder="Nome do Benefiário:"
                            formControlName="beneficiario">
                    </mat-form-field>
                </div>

                <div fxFlex="35%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <input matInput maxlength="255" name="mae" placeholder="Nome da Mãe:" formControlName="mae">
                    </mat-form-field>
                </div>

                <div fxFlex="15%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <input matInput name="cpf" placeholder="CPF:" formControlName="cpf"
                            [textMask]="{mask: mascaraCpf}">
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div fxFlex="35%" fxLayoutGap="20px">
                    <mat-form-field style="width: 100%;" fxLayoutGap="20px" fxFlexOffset="20px">
                        <input matInput name="dataInicioEntrada" [matDatepicker]="dataInicioEntrada"
                            placeholder="Data Início Entrada" formControlName="dataInicioEntradaInstituicao"
                            (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataInicioEntrada"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicioEntrada></mat-datepicker>
                    </mat-form-field>
                </div>

                <div fxFlex="35%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <input matInput name="dataFimEntrada" [matDatepicker]="dataFimEntrada"
                            placeholder="Data Fim Entrada" formControlName="dataFimEntradaInstituicao"
                            (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFimEntrada"></mat-datepicker-toggle>
                        <mat-datepicker #dataFimEntrada></mat-datepicker>
                    </mat-form-field>
                </div>
                <div fxFlex="15%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-checkbox fxFlex="10%" color="primary" [checked]="true"
                        name="ativo" formControlName="ativo">Ativo?
                    </mat-checkbox>   
                </div>
            </div>
            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>
                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="matricula">
                <th mat-header-cell *matHeaderCellDef> Matrícula: </th>
                <td mat-cell *matCellDef="let element"> {{element.matriculaAluno}} </td>
            </ng-container>

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef> Nome: </th>
                <td mat-cell *matCellDef="let element"> {{element.pessoaFisica.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="stAtivo">
                <th mat-header-cell *matHeaderCellDef> Aluno Ativo </th>
                <td mat-cell *matCellDef="let element"> {{element.stAtivo ? 'Sim' : 'Não'}} </td>
            </ng-container>

            <ng-container matColumnDef="participaApresentacaoExterna">
                <th mat-header-cell *matHeaderCellDef> Participa apresentações externas </th>
                <td mat-cell *matCellDef="let element"> {{element.participaApresentacaoExterna ? 'Sim' : 'Não'}} </td>
            </ng-container>

            <ng-container matColumnDef="paisCasados">
                <th mat-header-cell *matHeaderCellDef> Pais do beneficiário são casados? </th>
                <td mat-cell *matCellDef="let element"> {{element.paisCasados ? 'Sim' : 'Não'}} </td>
            </ng-container>


            <ng-container matColumnDef="moraPais">
                <th mat-header-cell *matHeaderCellDef> Mora com os Pais? </th>
                <td mat-cell *matCellDef="let element"> {{element.moraPais ? 'Sim' : 'Não'}} </td>
            </ng-container>

            <ng-container matColumnDef="turno">
                <th mat-header-cell *matHeaderCellDef> Turno: </th>
                <td mat-cell *matCellDef="let element"> {{element.turno}} </td>
            </ng-container>

            <ng-container matColumnDef="serie">
                <th mat-header-cell *matHeaderCellDef> Série: </th>
                <td mat-cell *matCellDef="let element"> {{element.serieEscola}} </td>
            </ng-container>

            <ng-container matColumnDef="dataEntrada">
                <th mat-header-cell *matHeaderCellDef> Data Admissão: </th>
                <td mat-cell *matCellDef="let element"> {{element.dataEntrada | dataSimples}} </td>
            </ng-container>

            <ng-container matColumnDef="dataDesligamento">
                <th mat-header-cell *matHeaderCellDef> Data Desligamento: </th>
                <td mat-cell *matCellDef="let element"> {{element.dataDesligamento | dataSimples}} </td>
            </ng-container>

            <ng-container matColumnDef="ativo">
                <th mat-header-cell *matHeaderCellDef> Ativo: </th>
                <td mat-cell *matCellDef="let element"> {{element.stAtivo | simNao}} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [length]="numberItens" [pageSizeOptions]="[10, 20, 40, 60, 80, 100]" showFirstLastButtons
                (page)="onEventPaginate($event)"></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar novo aluno" mat-fab color="primary" [routerLink]="['/aluno/cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>